<template>
    <section class="py-6 px-5" v-if="nonMunicipalOffices.length">
        <div class="container is-max-desktop padding-responsive">
            <div class="columns is-multiline">
                <div class="column is-full">
                    <header class="my-4">
                        <h3 class="titulo-bandera">Sucursales cercanas:</h3>
                    </header>
                </div>

                <div v-for="office in nonMunicipalOffices" class="column is-6-tablet is-4-widescreen">
                    <sucursal-card :office="office"></sucursal-card>
                </div>

            </div>
        </div>
    </section>
</template>
<script>
import SucursalCard from './SucursalCard.vue';

export default {
    components: {
        SucursalCard,
    },
    props: ['filteredOffices'],
    computed: {
        nonMunicipalOffices() {
            return this.filteredOffices.filter(office => !office.is_municipal)
        }
    }
}
</script>